import React from 'react';
import turfDistance from '@turf/distance';
import { LanguageSupportUtil } from '../../../../utils/language_support_util';
import { StringConstantsMixin } from '../mixins/shared/string_constants_mixin';
import { pointItemToLngLat } from '../../../../utils/mapbox/sources/point_items';
import { MapStatsUtil } from '../../../../utils/map_stats_util';

const createReactClass = require('create-react-class');

const SearchResultItem = createReactClass({
  handleClick(url, dataType, e) {
    e.preventDefault();
    e.stopPropagation();
    _gaq.push(['_trackEvent', 'Site Search', this.props.term, this.props.data.slug, this.props.idx + 1]);
    this.props.handleItemClick(url, this.props.data, this.props.idx + 1);
  },
  formatTrailInfo() {
    let resultString = '';
    const data = this.props.data;
    if (data.type == 'trail') {
      if (data.area_name && data.area_name != '')
        resultString += LanguageSupportUtil.findRecordFieldWithLocale(data, 'area_name', this.props.languageRegionCode);
      if (data.city_name && data.city_name != '')
        resultString +=
          (resultString == '' ? '' : ', ') + LanguageSupportUtil.findRecordFieldWithLocale(data, 'city_name', this.props.languageRegionCode);
      if (data.state_name && data.state_name != '')
        resultString +=
          (resultString == '' ? '' : ', ') + LanguageSupportUtil.findRecordFieldWithLocale(data, 'state_name', this.props.languageRegionCode);
      if (data.country_name && data.country_name != '' && data.country_id != 313)
        resultString +=
          (resultString == '' ? '' : ', ') + LanguageSupportUtil.findRecordFieldWithLocale(data, 'country_name', this.props.languageRegionCode);
    }
    return resultString;
  },
  formatLocationInfo() {
    let resultString = '';
    const data = this.props.data;
    if (data.type != 'trail') {
      if (data.type != 'area' || (data.area_type && data.area_type == 'C')) {
        if (data.city_name !== undefined && data.city_name != '' && data.city_name != null)
          resultString += (resultString == '' ? '' : ', ') + data.city_name;
      }
      if (data.state_name !== undefined && data.state_name != '' && data.state_name != null)
        resultString += (resultString == '' ? '' : ', ') + data.state_name;
      if (data.country_name != '' && data.country_name != undefined && (resultString == '' || data.country_name != 'United States of America'))
        resultString += (resultString == '' ? '' : ', ') + data.country_name;
    }
    return resultString;
  },
  createResultUrl() {
    switch (this.props.data.type) {
      case 'track':
        return `/explore/recording/${this.props.data.slug}`;
      case 'map':
        return `/explore/map/${this.props.data.slug}`;
      case 'list':
        return `/lists/${this.props.data.slug}`;
      default:
        return `/${this.props.data.slug}`;
    }
  },
  handleHover() {
    this.props.hoverHandle(this.props.idx);
  },
  render() {
    let formattedName = LanguageSupportUtil.findRecordFieldWithLocale(this.props.data, 'name', this.props.languageRegionCode);
    if (this.props.latLngForDisplayDistance) {
      const lngLat = this.props.latLngForDisplayDistance.slice().reverse();
      const areaDistanceTo = turfDistance(pointItemToLngLat(this.props.data), lngLat) * 1000;
      const formattedDistance = MapStatsUtil.metersToFormattedUserUnits(areaDistanceTo, 2, this.props.displayMetric, this.props.languageRegionCode);
      formattedName = `${formattedName}  (${formattedDistance})`;
    }
    const formattedTrailInfo = this.formatTrailInfo();
    const formattedLocationInfo = this.formatLocationInfo();
    const dataUrl = this.createResultUrl();
    let formattedUrl = null;
    let dataType = null;
    if (formattedUrl == null || this.props.data.type != 'trail') {
      formattedUrl = dataUrl;
      dataType = this.props.data.type;
    }
    const clickHandler = this.handleClick.bind(null, formattedUrl, dataType);

    let classes = 'algolia-hit';
    if (this.props.selected) classes += ' hit-selected';
    return (
      <div
        key={`search-result-item-${this.props.idx}`}
        className={classes}
        onMouseEnter={this.handleHover}
        onTouchStart={this.handleHover}
        onClick={clickHandler}
      >
        <a href={LanguageSupportUtil.wrapUrlSafe(formattedUrl)}>
          <span className={`hit-icon ${this.props.data.type}`} />
          <span className="search-text">
            <span className={`item-name-txt ${StringConstantsMixin.constants.XLATE.NONE}`} title={formattedName}>
              {formattedName}
            </span>
            <br />
            <span className={`trail-search-info ${StringConstantsMixin.constants.XLATE.NONE}`} title={formattedTrailInfo}>
              {formattedTrailInfo}
            </span>
            <span className={`location-search-info ${StringConstantsMixin.constants.XLATE.NONE}`} title={formattedLocationInfo}>
              {formattedLocationInfo}
            </span>
          </span>
        </a>
      </div>
    );
  }
});

export { SearchResultItem };
